import React from 'react'
import PropTypes from 'prop-types'
import { createGlobalStyle } from 'styled-components'
import DayPicker from 'react-day-picker'
import { getCurrentYear, getCurrentMonth } from 'tools/date'
import Day from './Day'
import WeekDay from './WeekDay'
import Caption, { MonthYearDropdown } from './Caption'
import NavBar from './NavBar'

// From: https://unpkg.com/react-day-picker@6.0.2/lib/style.css
const DayPickerGlobalStyle = createGlobalStyle`
  /* stylelint-disable */
  .DayPicker {
    display: inline-block;
    outline: 0;
  }

  .DayPicker-wrapper {
    display: flex;
    flex-wrap: wrap;
    -ms-flex-pack: center;
    justify-content: center;
    position: relative;
    user-select: none;
    flex-direction: row;
    padding: 1rem 0;
    outline: 0;
  }

  .DayPicker-Month {
    display: table;
    border-collapse: collapse;
    border-spacing: 0;
    user-select: none;
    margin: 0 1rem;
  }

  .DayPicker-Weekdays {
    display: table-header-group;
  }

  .DayPicker-WeekdaysRow {
    display: table-row;
  }

  .DayPicker-Body {
    display: table-row-group;
  }

  .DayPicker-Week {
    display: table-row;
  }

  .DayPicker-Day {
    display: table-cell;
    outline: 0;
  }

  .DayPicker-WeekNumber {
    display: table-cell;
  }
  /* stylelint-enable */
`

class DatePicker extends React.PureComponent {
  static propTypes = {
    ...DayPicker.propTypes,
    withMonthYearDropdown: PropTypes.bool,
    disabledDays: PropTypes.object,
    onChange: PropTypes.func,
    customCaption: PropTypes.any,
    CustomNavBar: PropTypes.element
  }

  static defaultProps = {
    fromMonth: new Date(getCurrentYear(), getCurrentMonth()),
    toMonth: new Date(getCurrentYear() + 1, 11),
    disabledDays: { before: new Date() },
    onChange: () => {},
    CustomNavBar: NavBar
  }

  constructor (props) {
    super(props)
    this.state = {
      month: props.month || props.selectedDays || new Date()
    }
  }

  handleDayClick = (day, { disabled }) => {
    const { name, onChange } = this.props
    !disabled && onChange(name, day)
  }

  handleMonthYearChange = (value) => {
    this.setState({ month: value })
  }

  getMonthYearDropdown = ({ date, localeUtils }) => (
    <MonthYearDropdown
      date={date}
      localeUtils={localeUtils}
      fromMonth={this.props.fromMonth}
      toMonth={this.props.toMonth}
      onChange={this.handleMonthYearChange} />
  )

  render () {
    const { selectedDays, withMonthYearDropdown, fromMonth, toMonth, disabledDays, customCaption, CustomNavBar, ...props } = this.props
    const CaptionElement = customCaption || (withMonthYearDropdown ? this.getMonthYearDropdown : Caption)

    return (
      <React.Fragment>
        <DayPickerGlobalStyle />
        <DayPicker
          fromMonth={fromMonth}
          toMonth={toMonth}
          month={this.state.month}
          renderDay={(day, modifiers) => <Day day={day} {...modifiers} />}
          weekdayElement={(props) => <WeekDay {...props} />}
          navbarElement={<CustomNavBar fromMonth={fromMonth} toMonth={toMonth} />}
          captionElement={CaptionElement}
          selectedDays={selectedDays}
          initialMonth={selectedDays}
          disabledDays={disabledDays}
          onDayClick={this.handleDayClick}
          {...props} />
      </React.Fragment>
    )
  }
}

export default DatePicker
